import React from 'react';
import { classNames } from '@fullstory/util/fmt';
import { JOINT_WIDTH, SPECIAL_ID_OTHER } from './const';
import { GraphLink, PageTypes } from './types';
import { makePath } from './util';
import { usePageFlow } from './hooks';
import css from './index.module.scss';

interface PageFlowLinkProps {
  link: GraphLink;
}

export const PageFlowLink: React.FC<PageFlowLinkProps> = ({ link }) => {
  const { selectedNode, onSelectNode, hoveredNode, onHoverNode } = usePageFlow();

  const selected =
    selectedNode?.internalId === link.source.internalId ||
    selectedNode?.internalId === link.target.internalId ||
    hoveredNode?.internalId === link.source.internalId ||
    hoveredNode?.internalId === link.target.internalId;
  const dimmed =
    !!selectedNode &&
    selectedNode?.internalId !== link.source.internalId &&
    selectedNode?.internalId !== link.target.internalId;

  const canInteract =
    link.source.pageDefId !== SPECIAL_ID_OTHER && link.target.pageDefId !== SPECIAL_ID_OTHER;

  const leafNode = link.target.type === PageTypes.EXIT ? link.target : link.source;
  const mouseInteractions = canInteract
    ? {
        onClick: () => onSelectNode(leafNode),
        onMouseEnter: () => onHoverNode(leafNode),
        onMouseLeave: () => onHoverNode(null),
      }
    : {};

  const path = (
    <path
      className={classNames(css.path, {
        [css.selected]: selected,
        [css.dimmed]: dimmed && !selected,
      })}
      strokeWidth={link.width}
      d={makePath(link.source.x, link.source.y, link.target.x, link.target.y)}
      {...mouseInteractions}
    />
  );
  if (link.target.type === PageTypes.EXIT) {
    return (
      <>
        {selected && (
          <rect
            x={link.source.x - JOINT_WIDTH}
            y={link.source.y - 0.5 * link.width}
            width={JOINT_WIDTH}
            height={link.width}
            className={css.joint}
          />
        )}
        {path}
        <rect
          x={link.target.x}
          y={link.target.y - 0.5 * link.width}
          width={JOINT_WIDTH}
          height={link.width}
          className={classNames(css.joint, { [css.dimmed]: dimmed && !selected })}
          {...mouseInteractions}
        />
      </>
    );
  }
  return (
    <>
      <rect
        x={link.source.x - JOINT_WIDTH}
        y={link.source.y - 0.5 * link.width}
        width={JOINT_WIDTH}
        height={link.width}
        className={classNames(css.joint, { [css.dimmed]: dimmed && !selected })}
        {...mouseInteractions}
      />
      {path}
      {selected && (
        <rect
          x={link.target.x}
          y={link.target.y - 0.5 * link.width}
          width={JOINT_WIDTH}
          height={link.width}
          className={css.joint}
        />
      )}
    </>
  );
};
